<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <v-snackbar v-model="showsnackbar" color="primary" right :timeout="timeout">
      {{msg}}
      <v-btn text @click="showsnackbar = false">
        <v-icon style="color:white;">mdi-close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="appConfirmation" width="500" persistent>
      <v-card>
        <v-card-title class="headline">
          <span style="font-size:16px;font-weight:600">Would you like to delete this Partner ?</span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#00a972" text @click="appConfirmation = false">Cancel</v-btn>
          <v-btn color="red" text @click="deleteProject">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex xs12 md12 pa-0>
        <v-card id="app_height" outlined tile>
          <v-layout wrap justify-space-around>
            <v-flex xs12 md12 pa-8>
              <v-layout wrap>
                <v-flex xs12 md12 text-center>
                  <span style="font-size:20px;font-weight:500;">Partners List</span>
                </v-flex>
              </v-layout>
              <v-layout wrap px-2 justify-center>
                <v-flex xs12 sm12 md12>
                    <!-- <v-layout wrap justify-space-around>
                      <v-flex xs6 md6>
                        <v-text-field
                          ref="PartnerName"
                          v-model="PartnerName"
                          prepend-icon="mdi-account"
                          label="Partner Name"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout> -->

                  <v-layout wrap justify-space-around>
                    <v-flex xs12 md12 pa-4>
                      <v-layout pt-5 wrap justify-center>
                        <v-flex text-center>
                          <span style="font-size:18px;font-weight:400">Add Partner Picture</span>

                          <p style="font-size:12px">Hint: Image size should be maximum 5mb</p>
                        </v-flex>
                      </v-layout>
                      <v-layout wrap px-2 justify-space-around>
                        <v-container>
                          <v-row no-gutters>
                            <v-col cols="12" sm="6">
                              <!-- <v-layout wrap justify-center>
                        <v-flex xs12 sm12 md12>
                          <img v-bind:src="baseURL+'/u/'+profilepic" height="auto" width="20%" />
                        </v-flex>
                              </v-layout>-->
                            </v-col>
                            <v-col cols="12" sm="6">
                              <v-layout wrap justify-center>
                                <v-flex xs12 sm12 md12 pb-3>
                                  <input
                                    id="pic"
                                    ref="uploadPicture"
                                    accept="image/*"
                                    type="file"
                                    @change="uploadPicture"
                                  />
                                </v-flex>
                              </v-layout>
                            </v-col>
                            <v-col cols="12" sm="6" lg="12">
                              <v-flex text-center>
                                <v-btn
                                  @click="submitPicture"
                                  rounded
                                  small
                                  dark
                                  :ripple="false"
                                  class="text-capitalize"
                                  color="#26af82"
                                  width="250"
                                >Add Partner Picture</v-btn>
                              </v-flex>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <v-data-table
                    :headers="headers"
                    :items="projects"
                    dense
                    :loading="appLoading"
                    loading-text="Loading... Please wait"
                    class="elevation-1"
                    color="#26af82"
                  >

                   <template v-slot:item.photo="{ item }">
              <span v-if="item.photo">
                <img v-bind:src="baseURL+'/document/get/'+item.photo" width="auto" height="100px" />
              </span>
            </template>
                    <template v-slot:item._id="{ item }">
                      <v-layout>
                        <v-flex>
                          <router-link tag='span' :to="'/ViewPartner/'+item._id">
                            <v-btn small text color="green" class="text-capitalize">View</v-btn>
                          </router-link>
                        </v-flex>
                        <v-flex>
                          <router-link tag='span' :to="'/EditPartner/'+item._id">
                            <v-btn small text color="blue" class="text-capitalize">Edit</v-btn>
                          </router-link>
                        </v-flex>
                        <v-flex>
                          <v-btn
                            @click="delModel(item)"
                            small
                            text
                            color="red"
                            class="text-capitalize"
                          >Delete</v-btn>
                        </v-flex>
                      </v-layout>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import VueElementLoading from "vue-element-loading";
import axios from "axios";
export default {
  components: {
    VueElementLoading
  },
  data() {
    return {
      appLoading: false,
      appConfirmation: false,
      showsnackbar: false,
      PartnerName: "",
      timeout: 3000,
      msg: null,
      //   search: null,
      picture: null,
      headers: [
       
        {
          text: "Photo",
          align: "left",
          sortable: true,
          value: "photo"
        },
        { text: "Action", align: "center", value: "_id" }
      ],
      projects: [],

      deleteId: null
    };
  },
  beforeMount() {
    this.getPratners();
  },

  methods: {
    uploadPicture(event) {
      this.picture = event.target.files[0];
      //   if (event.target.files[0].size > 5242880) {
      //     this.msg = "File Should be less than 5MB";
      //     this.showsnackbar = true;
      //     return;
      //   }
      this.url = URL.createObjectURL(this.picture);
    },

    submitPicture: function() {
      let formData = new FormData();
      formData.append("photo", this.picture);
      // data["name"] = this.PartnerName;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/partner/add",
        headers: {
          "Content-Type": "multipart/form-data",
          token: localStorage.getItem("token")
        },
        data: formData
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.getPratners();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch(err => {
          this.appLoading = false;
          this.ms = err.response;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },

    getPratners() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/partner/list",
        headers: {
          token: localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.projects = response.data.data;
        })
        .catch(err => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    delModel(event) {
      this.deleteId = event._id;
      this.appConfirmation = true;
    },
    deleteProject() {
      this.appConfirmation = false;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/partner/delete/" + this.deleteId,
        headers: {
          token: localStorage.getItem("token")
        }
      })
        .then(response => {
          this.appLoading = false;
          this.getPratners();
          this.msg = response.data.msg;
          this.showsnackbar = true;
        })
        .catch(err => {
          this.appLoading = false;
          this.msg = err.response.data.msg;
          this.showsnackbar = true;
        });
    }
  }
};
</script>
<style>
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
    min-width: 80vw;
  }
}
.centered-input input {
  text-align: center;
  height: 20px;
}
</style>